import { IntegrationsActionTypes } from './action-types';
export const initialIntegrationsState = {
  wordpressAuthResponse: {
    access_token: ``,
    expires_in: 0,
    portal_domain: ``,
    portal_id: 0,
    portal_name: ``,
    refresh_token: ``
  },
  wordpressValidPermissions: false,
  wordpressAuthFinished: false,
  wordpressAuthSucceeded: false
};
const integrationReducer = (state = initialIntegrationsState, action) => {
  switch (action.type) {
    case IntegrationsActionTypes.UpdateWordpressAuthorizationResponseAction:
      return Object.assign({}, state, {
        wordpressAuthResponse: Object.assign({}, action.wordpressAuthResponse),
        wordpressAuthSucceeded: true
      });
    case IntegrationsActionTypes.SetWordpressPermissions:
      return Object.assign({}, state, {
        wordpressValidPermissions: action.valid,
        wordpressAuthFinished: true
      });
    default:
      return state;
  }
};
export default integrationReducer;